import React from 'react';

import { OnboardingTemplateScreen } from '../components/onboarding/onboarding-template-screen/onboarding-template-screen';
import { ReportsContextProvider } from '../reports.context';
import { OnboardingContextProvider } from '../onboarding.context';
import { TemplatesContextProvider } from '../templates.context';
import { MembersContextProvider } from '../members-context';
import { PredictionsInfoContext } from '../../forecast/detail/context/predictions-info-context';

export const OnboardingContainer = () => {
  return (
    <PredictionsInfoContext>
      <OnboardingContextProvider>
        <ReportsContextProvider>
          <MembersContextProvider>
            <TemplatesContextProvider>
              <OnboardingTemplateScreen />
            </TemplatesContextProvider>
          </MembersContextProvider>
        </ReportsContextProvider>
      </OnboardingContextProvider>
    </PredictionsInfoContext>
  );
};
